import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { queryClient } from '@/shared/lib/tanstack'
import { CLAIMS_QUERY_KEYS } from '@/shared/constants/cache'
import { submitPetClaim } from '@/services/claims.services'

export function useSubmitPetClaim() {
  const { i18n } = useTranslation()

  return useMutation({
    mutationFn: async (claimId: string) => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return submitPetClaim(token, i18n.language, claimId)
    },
    // A submitted claim moves from drafts to filed and its files to the core
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CLAIMS_QUERY_KEYS.all }),
    onError: console.error,
  })
}
